import { ArrowDownIcon, ArrowLeftIcon } from 'components/icons';
import { ProductPropertyProps } from 'types/ProductPropertyProps';
import classNames from 'classnames';
import DesktopProductProperty from '../DesktopProductProperty/DesktopProductProperty';
import ProgressBar from 'components/atoms/ProgressBar/ProgressBar';
import React, { memo, useCallback } from 'react';
import styles from './RegistrationHeader.module.scss';

export interface RegistrationHeaderProps {
  progress: number;
  data: ProductPropertyProps[];
  calculatorOpened: boolean;
  onCalculatorToggle: () => void;
  logo: React.ReactNode;
  onBackBtnHandler?: () => void;
  hideEditButton?: boolean;
  loading?: boolean;
}

export default memo(function RegistrationHeader({
  data,
  calculatorOpened,
  onCalculatorToggle,
  progress,
  logo,
  onBackBtnHandler,
  hideEditButton,
  loading,
}: RegistrationHeaderProps) {
  const getSubHeaderElements = useCallback(
    () =>
      data &&
      data.map(({ title, type, value, unit }, pos: number) => {
        const separationElement = pos > 0 && <hr className={styles.vr} />;

        return (
          <div
            className={styles['container-subheader-element']}
            key={`registrationHeader-${pos}`}
          >
            {separationElement}
            <DesktopProductProperty
              value={value}
              valueSuffix={unit}
              label={title}
              loading={loading}
            />
          </div>
        );
      }),
    [data, loading],
  );

  return (
    <div
      className={classNames(
        styles.container,
        calculatorOpened && styles['opened'],
      )}
    >
      <div className={styles['container-header']}>
        {onBackBtnHandler && <ArrowLeftIcon onClick={onBackBtnHandler} />}
        <div className={styles['container-slider']}>
          <ProgressBar className={styles.slider} progress={progress} />
        </div>
        {logo}
      </div>
      <hr className={styles.hr} />
      <div className={styles['wrapper-subheader']}>
        <div className={styles['container-subheader']}>
          {getSubHeaderElements()}
        </div>
        {!hideEditButton && (
          <span className={styles.icon} onClick={onCalculatorToggle}>
            <ArrowDownIcon />
          </span>
        )}
      </div>
    </div>
  );
});
